import { render, staticRenderFns } from "./EditGroupModal.vue?vue&type=template&id=2084eaf2&"
import script from "./EditGroupModal.vue?vue&type=script&lang=js&"
export * from "./EditGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports